// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pa-6";
export var imgContainer = "_pa-3";
export var menuIcon = "_pa-5";
export var pillWrapper = "_pa-2";
export var pillsContainer = "_pa-1";
export var subscriptionCard = "_pa-0";
export var subscriptionLogo = "_pa-4";